const getStyles = () => {
  return {
    // Section
    section: {
      padding: '80px 0',
      background: 'linear-gradient(180deg, #ffffff 0%, #f1f5f9 100%)'
    },
    container: {
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '0 16px',
      '@media (min-width: 640px)': {
        padding: '0 24px'
      }
    },

    // Header
    header: {
      textAlign: 'center',
      marginBottom: '64px',
      animation: 'fadeIn 0.8s ease-out'
    },
    title: {
      fontSize: '2.25rem',
      fontWeight: 'bold',
      color: '#1a202c',
      marginBottom: '16px',
      '@media (min-width: 768px)': {
        fontSize: '3rem'
      }
    },
    subtitle: {
      fontSize: '1.25rem',
      color: '#6b7280',
      maxWidth: '500px',
      margin: '0 auto'
    },

    // Cards
    standardCard: {
      border: '2px solid #38bdf8',
      borderRadius: '16px',
      overflow: 'hidden',
      height: '100%',
      transition: 'all 0.3s ease',
      animation: 'fadeIn 0.8s ease-out',
      '&:hover': {
        boxShadow: '0 20px 40px rgba(56, 189, 248, 0.3)',
        transform: 'translateY(-8px)'
      }
    },
    addonCard: {
      border: '1px solid #e2e8f0',
      borderRadius: '16px',
      overflow: 'hidden',
      height: '100%',
      transition: 'all 0.3s ease',
      animation: 'fadeIn 0.8s ease-out',
      '&:hover': {
        boxShadow: '0 20px 40px rgba(0, 0, 0, 0.1)',
        transform: 'translateY(-8px)'
      }
    },

    // Headers inside Cards
    standardHeader: {
      background: 'linear-gradient(135deg, #4f46e5 0%, #38bdf8 100%)',
      color: '#ffffff',
      padding: '24px'
    },
    cardTitle: {
      fontSize: '1.75rem',
      fontWeight: 'bold'
    },
    cardSubheader: {
      color: 'rgba(255, 255, 255, 0.9)',
      fontSize: '0.9rem'
    },
    addonHeaderBox: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between'
    },
    addonTitle: {
      fontSize: '1.75rem',
      fontWeight: 'bold',
      color: '#1a202c'
    },

    // Features
    cardContent: {
      paddingTop: '24px',
      display: 'flex',
      flexDirection: 'column',
      gap: '16px'
    },
    featureItem: {
      display: 'flex',
      alignItems: 'flex-start',
      gap: '12px',
      animation: 'slideIn 0.6s ease-out forwards'
    },
    featureIconContainer: {
      width: '32px',
      height: '32px',
      borderRadius: '50%',
      backgroundColor: '#38bdf8',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
      marginTop: '2px'
    },
    addonIconContainer: {
      width: '32px',
      height: '32px',
      borderRadius: '50%',
      backgroundColor: '#f093fb',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
      marginTop: '2px'
    },
    checkIcon: {
      fontSize: '20px',
      color: '#ffffff'
    },
    featureText: {
      color: '#1a202c',
      fontWeight: 500
    },

    // Animations
    '@keyframes fadeIn': {
      '0%': { opacity: 0, transform: 'translateY(20px)' },
      '100%': { opacity: 1, transform: 'translateY(0)' }
    },
    '@keyframes slideIn': {
      '0%': { opacity: 0, transform: 'translateX(-20px)' },
      '100%': { opacity: 1, transform: 'translateX(0)' }
    }
  };
};

export default getStyles;
